import { Alpine } from '../core/alpine-core.js';
import { apiFetch } from './api.js';
import { getActiveLeagueId } from './league-context.js';

const LEAGUE_ID_KEY = 'dm.admin.league_id';

Alpine.data('adminLeagueLauncher', () => ({
  loading: true,
  leagues: [],

  async init() {
    await this.loadLeagues();
  },

  async loadLeagues() {
    this.loading = true;
    try {
      const res = await apiFetch('/dashboard-layout/meta');
      const data = await res.json().catch(() => ({}));
      const options = Array.isArray(data?.leagueOptions) ? data.leagueOptions : [];
      this.leagues = options
        .map((opt) => {
          const leagueKey = String(opt?.leagueKey || opt?.key || '').trim().toUpperCase();
          const label =
            String(opt?.label || opt?.name || leagueKey || '').trim() || leagueKey;
          return { leagueKey, label };
        })
        .filter((x) => x.leagueKey)
        .slice(0, 6);
    } catch {
      this.leagues = [];
    } finally {
      if (!this.leagues.length) {
        const fallback = getActiveLeagueId('PDL');
        this.leagues = [{ leagueKey: fallback, label: fallback }];
      }
      this.loading = false;
    }
  },

  mainDashboardHref() {
    return '/admin/dashboard';
  },

  leagueDashboardHref(leagueKey) {
    const clean = String(leagueKey || '').trim().toUpperCase();
    if (!/^[A-Z0-9_-]{1,24}$/.test(clean)) return '/admin/dashboard';
    return `/admin/l/${encodeURIComponent(clean)}`;
  },

  rememberLeagueSelection(leagueKey) {
    const clean = String(leagueKey || '').trim().toUpperCase();
    if (!/^[A-Z0-9_-]{1,24}$/.test(clean)) return;
    try {
      localStorage.setItem(LEAGUE_ID_KEY, clean);
    } catch {
      // ignore write failures
    }
  },
}));
